// extracted by mini-css-extract-plugin
export default {"loading":"activityDetail_loading__EeVUn","pcWrap":"activityDetail_pcWrap__bnI0R"};